/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import WebGLRenderGraph from "App/render/webgl/render_graph";
import WebGLContext from "App/web_gl_context";
import Canvas2DContext from "App/canvas_2d_context";
import RenderNode from "App/render/webgl/nodes/render_node";
import Pass from "App/render/webgl/passes/pass";
import IScene from "js_interface/src/scene_interface";

export default
class Renderable {
    protected _sceneAPI: IScene;
    protected _renderGraph: WebGLRenderGraph;
    protected _renderNode: RenderNode;
    protected _context: WebGLContext | Canvas2DContext;
    protected _typeName: string;

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aRenderNode: RenderNode) {
        this._sceneAPI = aSceneAPI;
        this._renderGraph = aRenderGraph;
        this._renderNode = aRenderNode;
        this._context = aRenderGraph.getContext();
    }

    public getClassTypeName() {
        return this._typeName;
    }

    public reCreate(aVerticesCount: number, aIndicesCount: number) {
    }

    public update() {
    }

    public render(aRenderPass: Pass) {
    }

    public release() {
    }
}
